import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Grid } from "@material-ui/core";
import InProcessCreateApplicationModal from "views/admin/components/Application/InProess/InProcessCreateApplicationModal";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { saveLoanApplicantDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import ConfirmationModal from "views/components/ConfirmationModal";
import { saveAadharTransaction } from "store/reducers/LoanApplication/LoanApplicationSlice";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { APPLICATION_CREATED_MESSAGE } from "assets/properties/properties";
import { saveSelfieDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { getPreviousDateAccToDays } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";
import { removeUnderscoresAndCapitalize } from "utils/Utils";
import { collateralOperationStatus } from "assets/properties/properties";
import { repledgeCaseListName } from "assets/properties/properties";
import { getDisbursalDatePreviousLoan } from "../Disbursal/SameDayProcessingFee";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import { maskMobileNumber } from "utils/Utils";
import { APPLICATION_SUB_TYPE_POST_PLEDGE } from "assets/properties/properties";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";

const InProess = ({ classes, seletedBranchCode, featureFlags, version}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModal1Header, setConfirmationModal1Header] = useState("");
  const [confirmationModal1Msg, setConfirmationModal1Msg] = useState("");
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  const [tableColumns, setTableColumns] = useState([
    { id: "leadid", label: "Lead ID" },
    { id: "created", label: "Created By" },
    { id: "formNumber", label: "Application Number" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "mobile", label: "Mobile Number" },
    { id: "type", label: "Application Type" },
    ...(enabledSendBackStageDetails
    ? [{ id: "stageHistory", label: "Stage History" }]
    : []),
    { id: "action", label: "Action" },
  ]);
  const [showInProcessApplication, setShowInProcessApplication] =
    useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [fromDate, setFromDate] = useState(getApplicationFromDate());
  const [toDate, setToDate] = useState(new Date());
  const [pendingUpdateParams, setPendingUpdateParams] = useState(null);
  const enabledPacketChangeInRenewalModal = parseAndSetFlag(
    featureFlags?.enabledPacketChangeInRenewalModal
  );
  const [collateralMovement, setCollateralMovement] = useState("");
  const handleFromDateChange = (e) => {
    setFromDate(e);
  };
  const handleToDateChange = (e) => {
    setToDate(e);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
    refetch: refetchApplicantData,
  } = useApplicantStatusData({
    status: "INPROCESS",
    fromDate,
    toDate,
    authToken,
    featureFlags,
    version,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    if (location && location.state && location.state.from === "aadhar-oauth") {
      onClickUpdateData(
        location.state.loanApplicationId,
        location.state.loanApplicationNumber,
        "AADHAR"
      );
    }
  }, [toast]);
  useEffect(() => {
    if (
      location &&
      location.state &&
      location.state.from === "selfie-liveness"
    ) {
      onClickUpdateData(
        location.state.loanApplicationId,
        location.state.loanApplicationNumber,
        "SELFIE",
        location.state.newOrnamentsToggle,
        location.state.mobileNumber,
      );
    }
  }, [toast]);

  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data?.sort((a, b) =>
      a?.loanApplicationId < b?.loanApplicationId ? 1 : -1
    );
    data &&
      data?.forEach((InProcessApplication, index) => {
        let row = {
          leadid: InProcessApplication.loanApplicationId,
          created: InProcessApplication.createdBy,
          formNumber: InProcessApplication.loanApplicationNumber,
          accountNumber: InProcessApplication.loanAccountNumber,
          customerid: InProcessApplication.customerId,
          customerName: InProcessApplication.customerName,
          mobile: maskMobileNumber(InProcessApplication.mobileNumber?.trim()),
          mobileNum: InProcessApplication.mobileNumber?.trim(),
          branchCode: InProcessApplication.branchCode?.trim(),
          type: `${removeUnderscores(
            InProcessApplication?.applicationType
          )} / ${removeUnderscores(InProcessApplication?.applicationSubType)}`,
          totalCollateralValue: InProcessApplication?.totalCollateralValue,
          applicationType: InProcessApplication?.applicationType,
          applicationSubType: InProcessApplication?.applicationSubType,
          hasSendBackHistory:
          Number(InProcessApplication?.applicationStageHistoryCount) > 0,
          ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  InProcessApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        InProcessApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
          action: GetAction(InProcessApplication?.loanApplicationId),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const GetAction = (loanApplicationId) => {
    return (
      <>
        <Button
          aria-label="Delete Disbursal"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            showDeleteResponse(loanApplicationId);
          }}
        >
          Reject
        </Button>
      </>
    );
  };
  const showDeleteResponse = (loanApplicationId) => {
    setConfirmationModalHeader("InProcess");
    setConfirmationModalMsg("Are you sure you want to Reject this entry");
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickDeleteData(loanAPPLICATIONID);
  };
  const handleNegativeResponse1 = () => {
    setConfirmationModal1(false);
    setConfirmationModal1Header("");
    setConfirmationModal1Msg("");
    if (pendingUpdateParams?.loanApplicationId) {
      onClickUpdateData(
        pendingUpdateParams.loanApplicationId,
        pendingUpdateParams.loanApplicationNumber,
        pendingUpdateParams.status,
        false,
        pendingUpdateParams.mobileNumber,
        pendingUpdateParams.clearAdharDetails,
        pendingUpdateParams.totalCollateralValue,
        pendingUpdateParams.branchCode,
      );
    }
  };
  const handlePositiveResponse1 = async () => {
    if (
      collateralMovement !== collateralOperationStatus?.inBranch &&
      collateralMovement !== collateralOperationStatus?.receivedFromHO
    ) {
      toastUpdate("Error", "Requested loan collateral is not in branch", true);
      return;
    }
    setConfirmationModal1(false);
    setConfirmationModal1Header("");
    setConfirmationModal1Msg("");
    if (pendingUpdateParams?.loanApplicationId) {
      onClickUpdateData(
        pendingUpdateParams.loanApplicationId,
        pendingUpdateParams.loanApplicationNumber,
        pendingUpdateParams.status,
        true,
        pendingUpdateParams.mobileNumber,
        pendingUpdateParams.clearAdharDetails,
        pendingUpdateParams.totalCollateralValue,
        pendingUpdateParams.branchCode,
      );
    }
  };
  const UnAssignPacketNumber = async (loanApplicationId) => {
    const res = await apiHandler({
      url: endpoint.UNASSIGN_PACKETS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    if (res?.data) {
      toastUpdate("Success", "Loan application rejected successfully", true);
      refetchApplicantData();
    }
  };
  const onClickDeleteData = async (id) => {
    const result = await apiHandler({
      url: endpoint.SANCTION_STATUS_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        loanApplicationId: id,
        status: "REJECTED",
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", "Error in REJECT of InProcess", true);
    } else {
      UnAssignPacketNumber(id);
    }
  };
  const checkForLeadOrnamentDetails = async (
    loanApplicationId,
    loanApplicationNumber,
    status,
    clearAdharDetails,
    mobileNumber,
    totalCollateralValue,
    branchCode,
    applicationSubType
  ) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      await checkCollateralMovement(loanApplicationId, applicationSubType);
    } else {
      if (loanApplicationId) {
        onClickUpdateData(
          loanApplicationId,
          loanApplicationNumber,
          status,
          !result?.data?.ornamentDetails?.[0]?.existingOrnament,
          mobileNumber,
          clearAdharDetails,
          totalCollateralValue,
          branchCode,
        );
      }
    }
  };
  const checkCollateralMovement = async (
        loanApplicationId,
        applicationSubType) => {
          setCallInProgress(true);
          const result = await apiHandler({
            url: `${endpoint.LOAN_STATUS}?loanApplicationId=${loanApplicationId}`,
            authToken,
          });
          const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
          const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
          const outstandingresult = await apiHandler({
            url:endpoint.CHECK_LOAN_STATUS + "?loanAccountNumber=" + prepledgeLoanAccountNumber?.toUpperCase(),
            method: "GET",
            authToken: authToken,
          });
          setCallInProgress(false);
          const confirmationMessage = applicationSubType === repledgeCaseListName?.renew ? "Do you want to change packet (delete unacceptable item/packet damage)" : `Do you want to ${removeUnderscoresAndCapitalize(applicationSubType)} with additional collateral`;
          setCollateralMovement(outstandingresult?.data?.collateralLoacation);
          setConfirmationModal1Header("Ornament Type");
          setConfirmationModal1Msg(confirmationMessage);
          setConfirmationModal1(true);
          return;
  }
  const onCLickCheckOrnaments = async (loanApplicationId,
  loanApplicationNumber,
  status = "INPROCESS",
  clearAdharDetails,
  mobileNumber,
  totalCollateralValue,
  branchCode,
  applicationType,
  applicationSubType,) => {
    if(applicationType === "RE_PLEDGE" && applicationSubType !== "PART_RELEASE" && enabledPacketChangeInRenewalModal){
      setPendingUpdateParams({
        loanApplicationId,
        loanApplicationNumber,
        status,
        clearAdharDetails,
        mobileNumber,
        totalCollateralValue,
        branchCode,
      });
      checkForLeadOrnamentDetails(
        loanApplicationId,
        loanApplicationNumber,
        status,
        clearAdharDetails,
        mobileNumber,
        totalCollateralValue,
        branchCode,
        applicationSubType
      );
    } else {
      onClickUpdateData(
        loanApplicationId,
        loanApplicationNumber,
        status,
        true,
        mobileNumber,
        clearAdharDetails,
        totalCollateralValue,
        branchCode,
      );
    }
  };
  const onClickUpdateData = async (
  loanApplicationId,
  loanApplicationNumber,
  status = "INPROCESS",
  oranmentNewType = true,
  mobileNumber,
  clearAdharDetails,
  totalCollateralValue,
  branchCode,
) => {
  try {
    dispatch(saveLoanApplicantDetails({ applicantDetails: "" }));

      const result = await apiHandler({
        url: `${endpoint.LOAN_STATUS}?loanApplicationId=${loanApplicationId}`,
        authToken,
      });
      const data = result?.data || {};

      let existingData = {}
      let applicationSubType = "";
      let btCase = "";
      const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
      const prepledgeLoanAccountNumber = data?.prepledgeLoanAccountNumber ? data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
      if (data?.applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE && Object.keys(prepledgeLoanMap).length > 0 ) 
        { 
          setCallInProgress(true); 
          const res = await apiHandler({ 
            url: endpoint.GET_ALL_DATA_MOBILE_NUMBER, 
            authToken, 
            method: "POST", 
            data: { 
              mobileNumber: mobileNumber, 
              source: "WEB", 
              renewalFlag: false, 
              toupFlag: false, 
              includeBtLoans: true, 
            }, 
          }); 
          setCallInProgress(false); 
          const loanList = Array.isArray(res?.data) ? res.data : []; 
          // Match prepledge loan accounts with API response 
          const matchedBTLoan = loanList.find( 
            (loan) => 
            Object.prototype.hasOwnProperty.call( 
              prepledgeLoanMap, 
              loan?.loanAccountNumber 
            ) && loan?.status?.toUpperCase() === "BT" 
          ); 
          if (matchedBTLoan?.loanAccountNumber) {
            btCase = matchedBTLoan.loanAccountNumber; 
          } 
          console.log("BT Case Loan:", btCase); 
        } // Final loan account to use for adjusted loan 
        const adjustedLoan = btCase ? btCase : prepledgeLoanAccountNumber; 
        console.log("prepledgeLoanAccountNumber:", prepledgeLoanAccountNumber); 
        console.log("btCase:", btCase); 
        console.log("adjustedLoan:", adjustedLoan);
      if (adjustedLoan) {
        const result1 = await apiHandler({
          url: `${endpoint.GET_ADJUSTED_LOAN_DATA}${adjustedLoan}`,
          authToken,
        });
        existingData=result1?.data
        const dataprevLoan = await apiHandler({
           url: endpoint.LOAN_STATUS + `?loanAccountNumber=${adjustedLoan?.trim()}`,
          authToken,
        });
        applicationSubType = dataprevLoan?.data?.applicationSubType || "";
      } 
      if (clearAdharDetails === "adharDetailsClear") {
        dispatch(saveAadharDetails(""));
        dispatch(saveAadharTransaction(""));
        dispatch(saveSelfieDetails(""));
      }

      const amountActual = await getDisbursalDatePreviousLoan(data?.applicationSubType, featureFlags, prepledgeLoanAccountNumber, authToken, loanApplicationId, setCallInProgress, applicationSubType, prepledgeLoanMap)

      const navigationData = {
        loanApplicationId,
        loanApplicationNumber,
        status,
        subStatus: data.applicationSubType || "",
        prePledgeLoan: prepledgeLoanAccountNumber || "",
        editable: false,
        loanType: data.applicationType || "",
        mobileNum: mobileNumber || existingData?.applicantDetailResponse?.mobileNumber,
        totalCollateralValue,
        leadBranchCode: branchCode,
        seletedBranchCode,
        newOrnaments: oranmentNewType,
        existingLoanData: existingData,
        actualLoanAmount:amountActual,
        prepledgeLoanMap:prepledgeLoanMap,
        version
      };
      navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const CreateApplication = () => {
    setShowInProcessApplication(true);
  };
  const closeInProcessApplication = (type) => {
    if (type) {
      toastUpdate("Success", APPLICATION_CREATED_MESSAGE, true);
    }
    setShowInProcessApplication(false);
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="InProcess Details"
          button1="Create Application"
          button1click={CreateApplication}
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={tableColumns}
          rows={selectedTableData}
          onClickUpdateData={onCLickCheckOrnaments}
          flag="inporcess"
        />
      </Grid>
      <StageHistoryModal
        open={stageHistoryModal}
        onClose={() => {
          setStageHistoryModal(false);
          setSelectedLeadId(null);
        }}
        leadId={selectedLeadId}
        authToken={authToken}
      />
      {showInProcessApplication && (
        <InProcessCreateApplicationModal
          showModal={showInProcessApplication}
          GetData={refetchApplicantData}
          closeModal={closeInProcessApplication}
          seletedBranchCode={seletedBranchCode}
        />
      )}

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {confirmationModal1 && (
        <ConfirmationModal
          confirmationModal={confirmationModal1}
          confirmationModalHeader={confirmationModal1Header}
          confirmationModalMsg={confirmationModal1Msg}
          handleNegativeButton={handleNegativeResponse1}
          handlePositiveButton={handlePositiveResponse1}
          negativeButtonText="No"
          positiveButtonText="Yes"
        />
      )}
      {(callInProgress || applicantDataLoading) && <CircularProgresss callInProgress />}
    </Grid>
  );
};

InProess.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default InProess;
